import { use } from 'react';
import { ModelerIsDirtyContext } from './ModelerIsDirtyContext';

export const useModelerIsDirtyContext = (): boolean => use(ModelerIsDirtyContext);
